import HeaderDesktop from "./HeaderDesktop";
import HeaderMobile from "./HeaderMobile";

function Header() {

    return (
        <>
            <HeaderDesktop />
            <HeaderMobile />
        </>
    );
}

export default Header;
